module.exports = __webpack_public_path__ + "img/guigang-2.f340abf8.png";